import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center mb-20" }
const _hoisted_5 = { class: "card-title fw-bold mb-0" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6 mb-15" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Date de naissance", -1)
const _hoisted_10 = { class: "fw-semibold text-black" }
const _hoisted_11 = { class: "col-md-6 mb-15" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Lieu de naissance", -1)
const _hoisted_13 = { class: "fw-semibold text-black" }
const _hoisted_14 = { class: "col-md-6 mb-15" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Contact", -1)
const _hoisted_16 = { class: "fw-semibold text-black" }
const _hoisted_17 = { class: "col-md-6 mb-15" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Pays d'origine", -1)
const _hoisted_19 = { class: "fw-semibold text-black" }
const _hoisted_20 = { class: "col-md-6 mb-15" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Pays de résidence", -1)
const _hoisted_22 = { class: "fw-semibold text-black" }
const _hoisted_23 = { class: "col-md-6 mb-15" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Ville de résidence", -1)
const _hoisted_25 = { class: "fw-semibold text-black" }
const _hoisted_26 = { class: "col-md-6 mb-15" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "D'Adjohoun", -1)
const _hoisted_28 = { class: "col-md-6 mb-15" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase" }, "Partisan", -1)
const _hoisted_30 = { class: "mt-20" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase mb-10" }, "Description", -1)
const _hoisted_32 = {
  class: "d-block fw-semibold text-black",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_33 = { class: "mt-20" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-body-tertiary fs-13 text-uppercase mb-10" }, "Secteurs d'activité", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 1,
  class: "text-body-tertiary"
}
const _hoisted_37 = {
  key: 1,
  class: "text-center text-body-tertiary py-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.recensement)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.recensement.nom) + " " + _toDisplayString(_ctx.recensement.prenom), 1),
              _createVNode(_component_router_link, {
                to: "/liste-recensements",
                class: "btn btn-danger transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_6,
                  _createTextVNode(" Retour ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.recensement.dateNaissance), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.recensement.LieuNaissance), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.recensement.contact), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.recensement.paysOrigine), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.recensement.PaysResidence), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.recensement.villeResidence), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.recensement.jeSuisDadjohoun ? 'badge text-white bg-success' : 'badge text-white bg-secondary')
                }, _toDisplayString(_ctx.recensement.jeSuisDadjohoun ? 'Oui' : 'Non'), 3)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.recensement.jeSuisPartisan ? 'badge text-white bg-success' : 'badge text-white bg-secondary')
                }, _toDisplayString(_ctx.recensement.jeSuisPartisan ? 'Oui' : 'Non'), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.recensement.description || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              (_ctx.recensement.secteuractivites && _ctx.recensement.secteuractivites.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recensement.secteuractivites, (secteur) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: secteur.id,
                        class: "badge bg-primary text-white me-5 mb-5"
                      }, _toDisplayString(secteur.libelle), 1))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_36, "Aucun secteur d'activité renseigné."))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, " Chargement... "))
    ])
  ]))
}